import { utilBuildings } from "../../../utils/utilBuildings";
import { selectAcresAvailable } from "../selectors/selectAcresAvailable";
export var checkAllAcreProductionDoneAvailable = function (path) { return function (action, state$, dependencies) {
    var state = state$.value;
    var acresAvailable = selectAcresAvailable(state);
    var haveAllAcresProduced = acresAvailable.every(utilBuildings.hasFinishedProduction);
    return haveAllAcresProduced ? path : undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/checks/checkAllAcreProductionDoneAvailable.ts
// module id = 2389
// module chunks = 3